import { FC } from 'react';
import { SFiltersWrapper } from '../styles';
import ItemFieldTemplatesFilters from './ItemFieldTemplatesFilters';
import ItemFieldTemplatesTable from './ItemFieldTemplatesTable';

interface Props {
    search: string;
    onSearch: (query: string) => void;
    archived: boolean;
}

const ItemFieldTemplatesTab: FC<Props> = ({ search, onSearch, archived }) => (
    <>
        <SFiltersWrapper>
            <ItemFieldTemplatesFilters onSearch={onSearch} />
        </SFiltersWrapper>
        <ItemFieldTemplatesTable archived={archived} search={search} />
    </>
);

export default ItemFieldTemplatesTab;
